import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import CopilotService from "../services/copilot.service";
import { updatePreferenceByUser } from "./auth";


import { rejectedList } from "./listState";
const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0,
};

export const createCopilotConversation = createAsyncThunk(
  "CopilotConversation/create",
  async ({ copilotConversation }, thunkAPI) => {
    try {
      const response = await CopilotService.createCopilotConversation(copilotConversation);

      const data = {
        data: response.data, 
        status: response.status,
      };


      thunkAPI.dispatch(CopilotSlice.actions.setActiveConversation(data.data.id));

      const preference = {
        preference_value: data.data.id,
        name: "currentConversation",
        username: copilotConversation.user,
      };
      thunkAPI.dispatch(updatePreferenceByUser({preference}));


      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const createCopilotPrompt = createAsyncThunk(
  "CopilotPromot/create",
  async ({ copilotPrompt }, thunkAPI) => {
    try {
      const response = await CopilotService.createCopilotPrompt(copilotPrompt);
      const id = copilotPrompt.conversationId
      thunkAPI.dispatch(getCopilotConversation({id}));

      const data = {
        data: response.data, 
        status: response.status,
      };


      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);



export const updateCopilotConversation = createAsyncThunk(
  "CopilotConversation/update",
  async ({ copilotConversation }, thunkAPI) => {
    try {
      const data = await CopilotService.updateCopilotConversation(copilotConversation);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);



export const getCopilotConversations = createAsyncThunk(
  "CopilotConversation/get_list",
  async ({ search, append = false }, thunkAPI) => {
    try {
      const data = await CopilotService.getCopilotConversations(search);
      return { conversations: data, append };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getCopilotConversation = createAsyncThunk(
  "CopilotConversation/get",

  async ({ id }, thunkAPI) => {
    try {
      const data = await CopilotService.getCopilotConversation(id);
      return { conversation: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const getCopilotPrompts = createAsyncThunk(
  "CopilotPrompt/get_list",
  async ({ search }, thunkAPI) => {
    try {
      const data = await CopilotService.getCopilotPrompts(search);
      return { prompts: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getCopilotPrompt = createAsyncThunk(
  "CopilotPrompt/get",

  async ({ id }, thunkAPI) => {
    try {
      const data = await CopilotService.getCopilotPrompt(id);
      return { prompt: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const getCopilotConversationFilterValues = createAsyncThunk(
  "CopilotConversation/get_filter_values_list",
  async ({ search }, thunkAPI) => {
    try {
      const data = await CopilotService.getCopilotConversationFilterValues(search);
      return { filter_values: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getCopilotPromptFilterValues = createAsyncThunk(
  "CopilotPrompt/get_filter_values_list",
  async ({ search }, thunkAPI) => {
    try {
      const data = await CopilotService.getCopilotPromptFilterValues(search);
      return { filter_values: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const getCopilotConversationUi = createAsyncThunk(
  "CopilotConversation/get_ui",
  async ({ }, thunkAPI) => {
    try {
      const data = await CopilotService.getCopilotConversationUi();
      return { ui: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getCopilotPromptUi = createAsyncThunk(
  "CopilotPrompt/get_ui",
  async ({ }, thunkAPI) => {
    try {
      const data = await CopilotService.getCopilotPromptUi();
      return { ui: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const updateCopilotFeedback = createAsyncThunk(
  "Copilot/update",
  async ({ prompt }, thunkAPI) => {
    try {
      const data = await CopilotService.updateCopilotFeedback(prompt);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);


const initialState = {
  conversation: {data: list , loading: false, Ui: [], filter_values: []},
  prompt: {data: list , loading: false, Ui: [] ,filter_values: []},
  activeConversationId: null,
}

const CopilotSlice = createSlice({
  name: "Copilot",
  initialState,

  reducers: {
    // Update a single prompt's fields in the store (used by the SSE stream).
    updatePromptFromStream: (state, action) => {
      const { id, ...fields } = action.payload;
      const idx = state.prompt.data.list.findIndex((p) => p.id === id);
      if (idx >= 0) {
        state.prompt.data.list[idx] = { ...state.prompt.data.list[idx], ...fields };
      }
    },
    setActiveConversation: (state, action) => {
      state.activeConversationId = action.payload;
    },
  },

  extraReducers: {

    [updateCopilotFeedback.fulfilled]: (state, action) => {

      const updatedPrompt = state.prompt.data.list.map((Prompt) => {
        if (Prompt.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return Prompt;
        }
      });

      state.prompt.data.list = updatedPrompt;

    },

    [getCopilotConversationUi.pending]: (state, action) => {
      state.conversation.loading = true;
    },
    [getCopilotConversationUi.fulfilled]: (state, action) => {
      state.conversation.Ui = action.payload.ui;
      state.conversation.loading = false;
    },
    [getCopilotConversationUi.rejected]: (state, action) => {
      state.conversation.Ui = null;
      state.conversation.loading = false;
    },
    
    [getCopilotPromptUi.pending]: (state, action) => {
      state.prompt.loading = true;
    },
    [getCopilotPromptUi.fulfilled]: (state, action) => {
      state.prompt.Ui = action.payload.ui;
      state.prompt.loading = false;
    },
    [getCopilotPromptUi.rejected]: (state, action) => {
      state.prompt.Ui = null;
      state.prompt.loading = false;
    },

    [getCopilotConversationFilterValues.pending]: (state, action) => {
      state.conversation.loading = true;
    },
    [getCopilotConversationFilterValues.fulfilled]: (state, action) => {
     

      state.conversation.filter_values = action.payload.filter_values;
      state.conversation.loading = false;
    },
    [getCopilotConversationFilterValues.rejected]: (state, action) => {
      state.conversation.filter_values = rejectedList(state.conversation.filter_values, action);
      state.conversation.loading = false;
    },


    [getCopilotPromptFilterValues.pending]: (state, action) => {
      state.prompt.loading = true;
    },
    [getCopilotPromptFilterValues.fulfilled]: (state, action) => {
     

      state.prompt.filter_values = action.payload.filter_values;
      state.prompt.loading = false;
    },
    [getCopilotPromptFilterValues.rejected]: (state, action) => {
      state.prompt.filter_values = rejectedList(state.prompt.filter_values, action);
      state.prompt.loading = false;
    },


    [createCopilotConversation.pending]: (state, action) => {
      state.conversation.loading = true;
    },
    [createCopilotConversation.fulfilled]: (state, action) => {

      state.conversation.data.list.push(action.payload.data.data);
      state.conversation.data.total ++;
      state.conversation.loading = false;
    },
    [createCopilotConversation.rejected]: (state, action) => {
      state.conversation.loading = false;
    },



    [createCopilotPrompt.pending]: (state, action) => {

      state.prompt.loading = true;
    },
    [createCopilotPrompt.fulfilled]: (state, action) => {

      state.prompt.data.list.push(action.payload.data.data);
      state.prompt.data.total ++;
      state.prompt.loading = false;
    },
    [createCopilotPrompt.rejected]: (state, action) => {
      state.prompt.loading = false;
    },



    [getCopilotConversations.pending]: (state, action) => {
      state.conversation.loading = true;
    },
    [getCopilotConversations.fulfilled]: (state, action) => {
      const { conversations, append } = action.payload;

      if (append) {
        const seen = new Set(state.conversation.data.list.map((c) => c.id));
        const merged = state.conversation.data.list.concat(
          (conversations.list || []).filter((c) => !seen.has(c.id))
        );
        state.conversation.data = { ...conversations, list: merged };
      } else {
        state.conversation.data = conversations;
      }

      state.conversation.loading = false;
    },
    [getCopilotConversations.rejected]: (state, action) => {
      state.conversation.loading = false;
    },



    // These write to prompt.loading, not conversation.loading: the history
    // panel keys its spinner off conversation.loading, so fetching a
    // conversation's messages must not spin the panel instead of the chat pane.
    [getCopilotPrompts.pending]: (state, action) => {
      state.prompt.loading = true;
    },
    [getCopilotPrompts.fulfilled]: (state, action) => {
      state.prompt.data = action.payload.prompts;
      state.prompt.loading = false;
    },
    [getCopilotPrompts.rejected]: (state, action) => {
      state.prompt.data = rejectedList(state.prompt.data, action);
      state.prompt.loading = false;
    },



    [updateCopilotConversation.fulfilled]: (state, action) => {
      state.conversation.data.list = state.conversation.data.list.map(
        (conversation) =>
          conversation.id === action.payload.data.id
            ? action.payload.data
            : conversation
      );
    },



    [getCopilotConversation.pending]: (state, action) => {
      state.conversation.loading = true;
    },
    [getCopilotConversation.fulfilled]: (state, action) => {

     

      const newPayload = action.payload.conversation;

      const existingIndex = state.conversation.data.list.findIndex(
        payload => payload.id === newPayload.id
      );
    
      if (existingIndex >= 0) {
        // The payload already exists, replace it
        state.conversation.data.list[existingIndex] = newPayload;
      } else {
        // The payload doesn't exist, add it
        state.conversation.data.list.push(newPayload);
      }


      state.conversation.loading = false;
    },
    [getCopilotConversation.rejected]: (state, action) => {
      state.conversation.loading = false;
    },


    
    [getCopilotPrompt.pending]: (state, action) => {
      state.prompt.loading = true;
    },
    [getCopilotPrompt.fulfilled]: (state, action) => {
      const newPayload = action.payload.prompt;

      const existingIndex = state.prompt.data.list.findIndex(
        (payload) => payload.id === newPayload.id
      );

      if (existingIndex >= 0) {
        const existing = state.prompt.data.list[existingIndex];

        // Merge: prefer non-empty response — never overwrite a populated
        // response with an empty one from a DB fetch that raced ahead of
        // AnswerPrompt's persist (or that arrived while updatePromptFromStream
        // already had the correct value from the SSE response event).
        const mergedResponse =
          newPayload.response && newPayload.response.trim() !== ""
            ? newPayload.response
            : existing.response;

        // Prefer "Completed" jobStatus — never downgrade from Completed to
        // Error/Failed due to a stale DB read racing with stream updates.
        const terminalErrorStatuses = ["Error", "Failed", "Stopped"];
        const mergedJobStatus =
          existing.jobStatus === "Completed" &&
          terminalErrorStatuses.includes(newPayload.jobStatus)
            ? existing.jobStatus
            : newPayload.jobStatus || existing.jobStatus;

        state.prompt.data.list[existingIndex] = {
          ...existing,
          ...newPayload,
          response: mergedResponse,
          jobStatus: mergedJobStatus,
        };
      } else {
        // New prompt not yet in the list — add it as-is.
        state.prompt.data.list.push(newPayload);
      }

      state.prompt.loading = false;
    },
    [getCopilotPrompt.rejected]: (state, action) => {
      state.prompt.loading = false;
    },



  },
});

const { reducer, actions } = CopilotSlice;
export const { updatePromptFromStream, setActiveConversation } = actions;
export default reducer;
